import { fetchAuthenticated_success } from "./authenticated.actions";
export const reducers = [
    [
        fetchAuthenticated_success,
        (state, { payload: { authenticated } }) => (Object.assign(Object.assign({}, state), authenticated)),
    ],
];
